<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "TradingTrialsStats",
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState('tradingTrials', [
      'stats',
    ]),
  },
  mounted() {
    if (!this.stats.active_trading_during_trial_ratio) {
      this.loadStats();
    }
  },
  methods: {
    ...mapActions('tradingTrials', ['getStats']),
    async loadStats() {
      try {
        this.loading = true;
        await this.getStats();
        this.loading = false;

      } catch (err) {
        console.error(err);
      }
    },
    updateStats() {
      this.loadStats();
    },
  }
}
</script>

<template>
  <div class="d-flex align-center">
    <v-table
        density="compact"
        style="max-width: 500px;"
    >
      <tbody>
      <tr>
        <td>Процент запустивших торговлю</td>
        <td>{{ stats.active_trading_during_trial_ratio ? Math.floor(stats.active_trading_during_trial_ratio * 100) / 100 : '-' }}</td>
      </tr>
      <tr>
        <td>Процент конвертаций в тариф всех триалов</td>
        <td>{{ stats.upgrades_after_trial_ratio ? Math.floor(stats.upgrades_after_trial_ratio * 100) / 100 : '-' }}</td>
      </tr>
      <tr>
        <td>Процент конвертаций в тариф триалов с активной торговлей</td>
        <td>{{ stats.upgrade_after_trial_with_active_trading_ratio ?? '-'}}</td>
      </tr>
      </tbody>
    </v-table>
    <v-btn
        prepend-icon="mdi-reload"
        density="comfortable"
        variant="text"
        size="small"
        :loading="loading"
        @click="updateStats"
    >
      Обновить
    </v-btn>
  </div>
</template>
